var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"config-card-content"},[_c('a-row',{attrs:{"gutter":18}},[_c('a-col',{attrs:{"span":8}},[_c('a-card',[_vm._t("left")],2)],1),_c('a-col',{attrs:{"span":16}},[_c('a-card',[_vm._t("right")],2)],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }